import { Pagination, Status } from "@/global/types.ts";

const DEFAULT_PAGINATION: Pagination = {
  pageNumber: 1,
  pageSize: 50
};

const DEFAULT_QUERY = {
  page: DEFAULT_PAGINATION.pageNumber,
  limit: DEFAULT_PAGINATION.pageSize
};
export const pathToNotification = "download/notifications";

const DEFAULT_FILE_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const EXPORT_EXCEL_LIMIT = 20000;

const ENVIRONMENT_VARS = {
  VITE_IS_HAWB_ENABLED: (import.meta.env.VITE_IS_HAWB_ENABLED as string) === "true",
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_API_CP_TRACKING_BASE_URL: import.meta.env.VITE_API_CP_TRACKING_BASE_URL,
  VITE_IAM_BASE_URL: import.meta.env.VITE_IAM_BASE_URL,
  VITE_IAM_ACCOUNT: import.meta.env.VITE_IAM_ACCOUNT,
  VITE_IS_PORT_CONGESTION_ENABLED: (import.meta.env.VITE_IS_PORT_CONGESTION_ENABLED as string) === "true",
  VITE_IS_SAVED_FILTERS_ENABLED: (import.meta.env.VITE_IS_SAVED_FILTERS_ENABLED as string) === "true",
  VITE_IS_EMISSIONS_ENABLED: (import.meta.env.VITE_IS_EMISSIONS_ENABLED as string) === "true",
  VITE_IS_DYNAMIC_CURRENCY_MAPPING_ENABLED:
    (import.meta.env.VITE_IS_DYNAMIC_CURRENCY_MAPPING_ENABLED as string) === "true",
  VITE_IS_NEW_SHIPMENTS_ENABLED: (import.meta.env.VITE_IS_NEW_SHIPMENTS_ENABLED as string) === "true",
  VITE_IS_DND_LEGACY_ENABLED: (import.meta.env.VITE_IS_DND_LEGACY_ENABLED as string) === "true",
  VITE_IS_RISK_MANAGEMENT_ENABLED: (import.meta.env.VITE_IS_RISK_MANAGEMENT_ENABLED as string) === "true",
  VITE_IS_NEW_DOWNLOAD_ENABLED: (import.meta.env.VITE_IS_NEW_DOWNLOAD_ENABLED as string) === "true",
  VITE_NEW_OUR_PREDICTION_LOGIC: (import.meta.env.VITE_NEW_OUR_PREDICTION_LOGIC as string) === "true",
  VITE_IS_SHIPMENT_MAP_ENABLED: (import.meta.env.VITE_IS_SHIPMENT_MAP_ENABLED as string) === "true",
  VITE_IS_METERING_ENABLED: (import.meta.env.VITE_IS_METERING_ENABLED as string) === "true",
  VITE_IS_COLLAPSIBLE_SIDEBAR_ENABLED: (import.meta.env.VITE_IS_COLLAPSIBLE_SIDEBAR_ENABLED as string) === "true",
  VITE_UPLOAD_CHUNK_SIZE: Number(import.meta.env.VITE_UPLOAD_CHUNK_SIZE) || 100
};

const BUCKETID_TO_APPEARANCE = {
  B3: "warning",
  B4: "error"
};

export {
  DEFAULT_QUERY,
  DEFAULT_FILE_TYPE,
  EXPORT_EXCEL_LIMIT,
  ENVIRONMENT_VARS,
  DEFAULT_PAGINATION,
  BUCKETID_TO_APPEARANCE
};

export enum ViewMode {
  TABLE = "table",
  MAP = "map"
}

export const NotificationStatus = {
  [Status.SUCCESSFUL]: "SUCCESSFUL",
  [Status.FAILED]: "FAILED",
  [Status.IN_PROGRESS]: "IN_PROGRESS",
  [Status.QUEUED]: "QUEUED"
};
export const PAGE_LAYOUT = {
  ONE_ROW_ONE_COLUMN: "1:1",
  ONE_ROW_TWO_COLUMN: "1:2"
};
